module.exports = __webpack_public_path__ + "static/media/tier-7.cd42cfb4.jpg";